export default __webpack_public_path__ + "static/media/mist_veiled_lead_elixir.42e9e37a.png";